import { usuarioService } from '@/services/usuarioService';

const state = {
  usuarios: []
}

const getters = {
  usuarios: state => state.usuarios,
}

const actions = {
  async fetchUsuarios({ commit }, { page, limit, status, query }) {
    commit('SET_LOADING', true);
    try {
      const response = await usuarioService.getAll(page, limit, status, query);
      commit('SET_USUARIOS', response.data.data);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_USUARIOS', []);
      commit('SET_LOADING', false);
    }
  },
  async addUsuario({ commit }, usuario) {
    commit('SET_LOADING', true);
    try {
      const response = await usuarioService.create(usuario);
      commit('SET_USUARIO', response.data.data);
      commit('SET_LOADING', false);
      return true;
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
      return false;
    }
  },
  async updateUsuario({ commit }, updUsuario) {
    commit('SET_LOADING', true);
    try {
      const response = await usuarioService.update(updUsuario);
      commit('UPDATE_USUARIO', response.data.data);
      commit('SET_LOADING', false);
      return true;
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
      return false;
    }
  },
  async deleteUsuario({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      await usuarioService.destroy(id);
      commit('DELETE_USUARIO', id);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
    }
  },
}

const mutations = {
  SET_USUARIOS: (state, usuarios) => state.usuarios = usuarios,
  SET_USUARIO: (state, usuario) => state.usuarios.push(usuario),
  UPDATE_USUARIO: (state, updUsuario) => {
    const index = state.usuarios.findIndex(usuario => usuario._id === updUsuario._id)
    if (index !== -1) state.usuarios.splice(index, 1, updUsuario);
  },
  DELETE_USUARIO: (state, id) => state.usuarios = state.usuarios.filter(usuario => usuario._id !== id)
}

export default {
  state,
  getters,
  actions,
  mutations
}